import type { ComponentProps } from "react";
import { LuSmilePlus } from "react-icons/lu";

import { EDITOR_MEDIA_TAB } from "@/components/app/editor-v3/constants";
import { useEditorContext } from "@/components/app/editor-v3/editor-context";
import { Button } from "@/components/ui/button";

export const EditorActionEmoji = (props: ComponentProps<typeof Button>) => {
  const { setEditorContext, activeMediaTab } = useEditorContext();

  return (
    <Button
      {...props}
      onClick={() => {
        setEditorContext({
          activeMediaTab:
            activeMediaTab === EDITOR_MEDIA_TAB.Emoji
              ? null
              : EDITOR_MEDIA_TAB.Emoji,
        });
      }}
    >
      <LuSmilePlus className="text-lg" />
    </Button>
  );
};
